"use strict";function trustedUrl($sce){return function(url){return $sce.trustAsResourceUrl(url)}}angular.module("app").filter("trustedUrl",trustedUrl);